var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatmentTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.78484,
    y: 2.57,
    width: 8.86,
    height: 10.86,
    rx: 1.43,
    stroke: "currentColor",
    strokeWidth: 1.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73725 6.01639C5.78885 5.93899 5.84798 5.86687 5.91376 5.80109L5.98528 5.72957C6.42174 5.29311 7.08724 5.18206 7.64176 5.45316L7.6971 5.48022C7.85832 5.55903 8.0354 5.6 8.21484 5.6C8.39429 5.6 8.57137 5.55903 8.73259 5.48022L8.78793 5.45316C9.34245 5.18206 10.0079 5.29311 10.4444 5.72957L10.5159 5.80109C10.5817 5.86687 10.6408 5.93899 10.6924 6.01639C11.0088 6.49091 11.0088 7.10909 10.6924 7.58361L10.586 7.74323C10.2136 8.30189 10.0148 8.95829 10.0148 9.6297V10.0418C10.0148 10.2774 9.96 10.5097 9.85465 10.7204L9.84466 10.7404C9.7651 10.8995 9.60246 11 9.42456 11C9.23667 11 9.06686 10.888 8.99284 10.7153L8.6373 9.88573C8.47812 9.51431 7.95157 9.51431 7.79239 9.88573L7.43685 10.7153C7.36283 10.888 7.19302 11 7.00513 11C6.82722 11 6.66459 10.8995 6.58502 10.7404L6.57504 10.7204C6.46969 10.5097 6.41484 10.2774 6.41484 10.0418V9.6297C6.41484 8.95829 6.2161 8.30189 5.84367 7.74323L5.73725 7.58361C5.42091 7.10909 5.42091 6.49091 5.73725 6.01639Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21484 2H10.2148",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentTab);
export default __webpack_public_path__ + "static/media/treatment-tab.fadbcc0addd0d9d648063ab726b5f9b0.svg";
export { ForwardRef as ReactComponent };